/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { Record } from 'immutable'
import ReservationEvent from '../../event/ReservationEvent'

const Receptionist = Record({
  active: false
})

class ReceptionistStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new Receptionist()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case ReservationEvent.showDetail:
        return state.merge({ active: true })
      case ReservationEvent.hideDetail:
        return state.merge({ active: false })
      default:
        return state
    }
  }
}

export default new ReceptionistStore()
